import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentBadge16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconDocumentBadge16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 13a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1h4.5A1.5 1.5 0 0 0 9 11.5v-1A1.5 1.5 0 0 0 7.5 9H3V3a1 1 0 0 1 1-1h4v5h5zM2 9.085V3a2 2 0 0 1 2-2h4.434a2 2 0 0 1 1.336.512l-.668.744A1 1 0 0 0 9 2.176V6h3.98a1 1 0 0 0-.312-.544l-3.566-3.2.668-.744 3.566 3.2A2 2 0 0 1 14 6.2V13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-.085A1.5 1.5 0 0 1 1 11.5v-1a1.5 1.5 0 0 1 1-1.415M2.5 12h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentBadge16);
